import { useState } from "react";

import { RegulatoryListData } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";

import RegulatoryCheckStatusGuide from "./components/RegulatoryTableShellForRegulatoryTitle/components/RegulatoryCheckStatusGuide/RegulatoryCheckStatusGuide";
import RegulatoryTableShellForRegulatoryTitle from "./components/RegulatoryTableShellForRegulatoryTitle/RegulatoryTableShellForRegulatoryTitle";
import RegulatoryGuideModal from "../RegulatoryGuideModal/RegulatoryGuideModal";
import RegulatoryPageEntryGuide from "../RegulatoryPageEntryGuide/RegulatoryPageEntryGuide";

type Props = {
  regulatoryListItem: RegulatoryListData;
  updateRegulatoryList: () => void;
};

const RegulatoryTitleContainer = ({
  updateRegulatoryList,
  regulatoryListItem,
}: Props) => {
  const [targetRegulatoryId, setTargetRegulatoryId] = useState(0);
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const { isModal, closeModal, openModal } = useModal();
  const {
    isModal: isGuideModal,
    closeModal: closeGuideModal,
    openModal: openGuideModal,
  } = useModal();
  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleTargetRegulatoryId = (id: number) => {
    setTargetRegulatoryId(id);
  };

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  const openAccessDeniedModal = (regulatoryId: number) => {
    handleTargetRegulatoryId(regulatoryId);
    openGuideModal();
  };

  const openConcurrentAccessDeniedModal = (regulatoryId: number) => {
    handleTargetRegulatoryId(regulatoryId);
    openModal();
  };

  return (
    <>
      <RegulatoryTableShellForRegulatoryTitle
        key={regulatoryListItem.id}
        regulatoryData={regulatoryListItem}
        openCheckStatusModal={openCheckStatusModal}
        openAccessDeniedModal={() =>
          openAccessDeniedModal(regulatoryListItem?.draftArticleId || 0)
        }
        openConcurrentAccessDeniedModal={() =>
          openConcurrentAccessDeniedModal(
            regulatoryListItem?.draftArticleId || 0,
          )
        }
        handleTargetRegulatoryId={() =>
          handleTargetRegulatoryId(regulatoryListItem?.draftArticleId || 0)
        }
        handleCurrentStatus={handleCurrentStatus}
      />

      {isModal && (
        <RegulatoryPageEntryGuide
          closeModal={closeModal}
          updateRegulatoryList={updateRegulatoryList}
        />
      )}
      {isGuideModal && (
        <RegulatoryGuideModal
          closeModal={closeGuideModal}
          draftArticleId={targetRegulatoryId}
        />
      )}
      {isCheckStatusModal && (
        <RegulatoryCheckStatusGuide
          closeModal={closeCheckStatusModal}
          regulatoryData={regulatoryListItem}
          updateRegulatoryList={updateRegulatoryList}
          openAccessDeniedModal={openGuideModal}
          openConcurrentAccessDeniedModal={openModal}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default RegulatoryTitleContainer;
